'use strict';

const $tips = $('[data-tutorial-tip]');

$tips.each(function () {
	const $tip = $(this);
	const id = $tip.attr('data-tutorial-tip');

	const $modal = $('[data-tutorial-tip-modal="' + id + '"]');
	
	$tip.click(function () {
		if ($tip.attr('data-tutorial-active') == 'true') {
			$modal.modal();
		}
	});
});
